import * as action from "./actions";

export const getPromoEvents = zoneId => {
  return {
    type: action.GET_PROMOEVENTS,
    payload: {},
    zoneId: zoneId
  };
};

const ACTION_HANDLERS = {
  [action.GET_PROMOEVENTS]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.SET_PROMOEVENTS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
